module.exports = __webpack_public_path__ + "images/emoji/rat.e1bf3825cc5e456b1d2f.png";